export const shiftsSelector = state => state.shifts;
